export const version = 'kunde-v1.20.0-SNAPSHOT-09d6383c854962e3d89eaf4dc0f68f1930a84e8b';